export const isEmptyValue = (value: any): boolean => value === undefined || value === null || value === "";

export const firstNonEmpty = (...values: Array<any>) => values.find((value) => !isEmptyValue(value));
